

























































































































import { Component, Vue } from 'vue-property-decorator';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import GiganautVue from '@/components/Shared/GiganautVue';
import WorkerSendTestPushNotification from '@/components/Workers/WorkerSendTestPushNotification.vue';
import WorkerEmailAddressUsernameEdit from '@/components/Workers/WorkerEmailAddressUsernameEdit.vue';
import WorkerUserSimulateApp from '@/components/Workers/WorkerUserSimulateApp.vue'
import { VuetifyConfirmObject } from 'vuetify-confirm';
import Alert from '../Shared/Alert.vue';

@Component({
  name: 'WorkerUserDetails',
  components: { WorkerSendTestPushNotification, WorkerUserSimulateApp, WorkerEmailAddressUsernameEdit, Alert }
})
export default class extends GiganautVue {

	get currentWorker() {
		return WorkerDetailsModule.currentWorker;
	}

	async inviteWorkerUser() {
		const options: VuetifyConfirmObject = {
			buttonTrueText: "INVITE",
			buttonFalseText: "CANCEL",
			buttonTrueColor: "primary",
			buttonFalseColor: "primary",
		};
		const result = await this.$confirm(
			"Are you sure you want to invite this worker to use Giganaut to manage their shifts? An invite will be send to " + this.currentWorker.emailAddress + ".",
			options
		);
		if (result) {
			await WorkerDetailsModule.inviteUser();
		}
	}

	async resetInvite() {
		const options: VuetifyConfirmObject = {
			buttonTrueText: "RESET",
			buttonFalseText: "CANCEL",
			buttonTrueColor: "primary",
			buttonFalseColor: "primary",
		};
		const result = await this.$confirm(
			"Are you sure you want to reset this invite code? This will invalidate the previous code.",
			options
		);
		if (result) {
			await WorkerDetailsModule.resetInvite();
		}
	}

	async resetEmailVerification() {
		const options: VuetifyConfirmObject = {
			buttonTrueText: "RESET",
			buttonFalseText: "CANCEL",
			buttonTrueColor: "primary",
			buttonFalseColor: "primary",
		};
		const result = await this.$confirm(
			"Are you sure you want to reset this workers email verification status? A verification link will be sent to " + this.currentWorker.emailAddress + ".",
			options
		);
		if (result) {
			await WorkerDetailsModule.resetEmailVerification();
		}
	}

	async resendEmailVerification() {
		const options: VuetifyConfirmObject = {
			buttonTrueText: "RESEND",
			buttonFalseText: "CANCEL",
			buttonTrueColor: "primary",
			buttonFalseColor: "primary",
		};
		const result = await this.$confirm(
			"Are you sure you want to resend this workers email address verification email? A verification link will be sent to " + this.currentWorker.emailAddress + ".",
			options
		);
		if (result) {
			await WorkerDetailsModule.resendEmailVerification();
		}
	}
}
